export const isObjectEmpty = obj => Object.getOwnPropertyNames(obj).length === 0;
